// @ts-strict-ignore
import type { PresentationalToken } from '../../editor/components/mla/types';
import { generateTokensWithLabelCasing } from './accountHistory';

export function customizeEHDistinctPIIMLAFootnote({
  processedTokens,
}: {
  processedTokens: PresentationalToken[];
}) {
  const presentationalTokens = generateTokensWithLabelCasing({ processedTokens });

  const piiStatusTokenIndex = presentationalTokens.findIndex(token => token.placeholder === '{pii_status}');
  if (piiStatusTokenIndex > -1) {
    const piiStatus = presentationalTokens[piiStatusTokenIndex].value;
    if (typeof piiStatus === 'string') {
      presentationalTokens[piiStatusTokenIndex].value = [piiStatus];
    }
    const incomingValue = (presentationalTokens[piiStatusTokenIndex].value as string);
    if (incomingValue) {
      presentationalTokens[piiStatusTokenIndex].label = `with the PII status of ${incomingValue}`;
      presentationalTokens[piiStatusTokenIndex].value = null;
      presentationalTokens[piiStatusTokenIndex].component = null;
      presentationalTokens[piiStatusTokenIndex].isOptional = false;
    } else {
      presentationalTokens.splice(piiStatusTokenIndex, 1);
    }
  }

  return presentationalTokens;
}
